import { isValid } from 'date-fns';
import { useCallback } from 'react';
import { useFormatTime, useParseTime } from '../../../hooks';

export const useGetParsedStartTime = () => {
  const parseTime = useParseTime();
  const formatTime = useFormatTime();

  return useCallback(
    (value?: string) => {
      if (!value) {
        return undefined;
      }

      const normalizedValue = value.trim();
      const parsedTime = parseTime(normalizedValue);

      if (!isValid(parsedTime)) {
        return undefined;
      }

      const formattedTime = formatTime(parsedTime);

      if (formattedTime.toLowerCase() === normalizedValue.toLowerCase()) {
        return formattedTime;
      }

      return undefined;
    },
    [formatTime, parseTime],
  );
};
